/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Lorem Ipsum?`)
};

const es_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es Lorem Ipsum?`)
};

const de_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Lorem Ipsum?`)
};

const nl_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is Lorem Ipsum?`)
};

const fr_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que Lorem Ipsum ?`)
};

const it_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cos'è Lorem Ipsum?`)
};

const pt_br2_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é Lorem Ipsum?`)
};

const pt_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é Lorem Ipsum?`)
};

const ja_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorem Ipsumとは？`)
};

const zh_li_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是Lorem Ipsum？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_faq1_q", locale)
	if (locale === "en") return en_li_faq1_q(inputs)
	if (locale === "es") return es_li_faq1_q(inputs)
	if (locale === "de") return de_li_faq1_q(inputs)
	if (locale === "nl") return nl_li_faq1_q(inputs)
	if (locale === "fr") return fr_li_faq1_q(inputs)
	if (locale === "it") return it_li_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_li_faq1_q(inputs)
	if (locale === "pt") return pt_li_faq1_q(inputs)
	if (locale === "ja") return ja_li_faq1_q(inputs)
	return zh_li_faq1_q(inputs)
};